import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import get from 'lodash/get'

import '@fontsource/inter'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import '@fontsource/inter/900.css'
import { getBackClient } from 'shared/controllers/back'
import config from 'src/config'

import PACKAGE from '../package.json'
import jsLogger from 'js-logger'
import { ErrorBoundary } from 'react-error-boundary'
import LocalizationContextDataProvider from 'shared/contexts/LocalizationContextDataProvider'

jsLogger.useDefaults()
jsLogger.setLevel(jsLogger.DEBUG)

getBackClient().initErrorsLogger(`${config.apiUrl}/clientErrorLogs`)

jsLogger.log('Demo 2, version:', PACKAGE.version, process.env)

const logError = (error: Error, info: any) => {
  jsLogger.error('Unexpected error occurried', {
    error,
    info,
    componentStack: get(info, 'componentStack')
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ErrorBoundary fallback={<div>Something went wrong</div>} onError={logError}>
    <LocalizationContextDataProvider>
      <App />
    </LocalizationContextDataProvider>
  </ErrorBoundary>
)
